import isSSR from '../../../utils/isSSR';
import gtmTimelineDecadeNavigationClick from '../../../core/gtm/gtmTimelineDecadeNavigationClick';
import gtmTimelineYearNavigationClick from '../../../core/gtm/gtmTimelineYearNavigationClick';
import gtmTimelineMobileDecadeNavigationClick from '../../../core/gtm/gtmTimelineMobileDecadeNavigationClick';
// Get the decades title
export const getDecadeTitle = (title) => (title ? `${title}'s` : '');
export const getFieldMapping = (timelineSitecoreFields) => {
    var _a, _b;
    const { fields } = timelineSitecoreFields || {};
    const mapLineItem = (lineItem) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
        if (!lineItem) {
            return {};
        }
        return {
            category: (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.value,
            subTitle: (_d = (_c = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _c === void 0 ? void 0 : _c.subTitle) === null || _d === void 0 ? void 0 : _d.value,
            title: (_f = (_e = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _e === void 0 ? void 0 : _e.title) === null || _f === void 0 ? void 0 : _f.value,
            bodyText: (_h = (_g = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _g === void 0 ? void 0 : _g.bodyText) === null || _h === void 0 ? void 0 : _h.value,
            cta: {
                linkField: (_j = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _j === void 0 ? void 0 : _j.ctaLink,
                typeField: (_k = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _k === void 0 ? void 0 : _k.ctaType,
                iconField: (_l = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _l === void 0 ? void 0 : _l.ctaIcon,
            },
            textContentAlignment: (_o = (_m = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _m === void 0 ? void 0 : _m.textContentAlignment) === null || _o === void 0 ? void 0 : _o.value,
            videoUrl: (_q = (_p = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _p === void 0 ? void 0 : _p.videoUrl) === null || _q === void 0 ? void 0 : _q.value,
            mediaImage: {
                src: (_t = (_s = (_r = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _r === void 0 ? void 0 : _r.mediaImage) === null || _s === void 0 ? void 0 : _s.value) === null || _t === void 0 ? void 0 : _t.src,
                alt: (_w = (_v = (_u = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _u === void 0 ? void 0 : _u.mediaImage) === null || _v === void 0 ? void 0 : _v.value) === null || _w === void 0 ? void 0 : _w.alt,
            },
            backgroundColor: (_y = (_x = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _x === void 0 ? void 0 : _x.backgroundColor) === null || _y === void 0 ? void 0 : _y.value,
            backgroundImage: {
                src: (_1 = (_0 = (_z = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _z === void 0 ? void 0 : _z.backgroundImage) === null || _0 === void 0 ? void 0 : _0.value) === null || _1 === void 0 ? void 0 : _1.src,
                alt: (_4 = (_3 = (_2 = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fields) === null || _2 === void 0 ? void 0 : _2.backgroundImage) === null || _3 === void 0 ? void 0 : _3.value) === null || _4 === void 0 ? void 0 : _4.alt,
            },
        };
    };
    const mapYearGTM = (year) => {
        var _a, _b, _c;
        if (!(year === null || year === void 0 ? void 0 : year.fields))
            return {
                componentParameters: {},
            };
        return {
            componentParameters: {
                'data-gtm-label': `${year.fields.year.value}`,
                'data-gtm-component-type': 'TimelineYear',
                'data-gtm-interaction-type': (_a = year.fields.gtmInteractionType) === null || _a === void 0 ? void 0 : _a.value,
            },
            gtm: {
                interactionType: (_b = year.fields.gtmInteractionType) === null || _b === void 0 ? void 0 : _b.value,
                type: 'TimelineYear',
                title: (_c = year.fields.gtmTitle) === null || _c === void 0 ? void 0 : _c.value,
            },
            gtmEvent: gtmTimelineYearNavigationClick,
        };
    };
    const mapDecadeGTM = (decade) => {
        var _a, _b, _c;
        if (!(decade === null || decade === void 0 ? void 0 : decade.fields))
            return {
                componentParameters: {},
            };
        return {
            componentParameters: {
                'data-gtm-label': `${decade.fields.decade.value}`,
                'data-gtm-component-type': 'TimelineDecade',
                'data-gtm-interaction-type': (_a = decade.fields.gtmInteractionType) === null || _a === void 0 ? void 0 : _a.value,
            },
            gtm: {
                interactionType: (_b = decade.fields.gtmInteractionType) === null || _b === void 0 ? void 0 : _b.value,
                type: 'TimelineDecade',
                title: (_c = decade.fields.gtmTitle) === null || _c === void 0 ? void 0 : _c.value,
            },
            gtmEvent: gtmTimelineDecadeNavigationClick,
        };
    };
    const mapDecadeMobileGTM = (decade) => {
        if (!(decade === null || decade === void 0 ? void 0 : decade.fields))
            return {
                componentParameters: {},
            };
        const title = getDecadeTitle(decade.fields.decade.value);
        return {
            componentParameters: {
                'data-gtm-label': title,
            },
            gtm: {
                interactionType: '',
                type: 'Accordion',
                title,
            },
            gtmEvent: gtmTimelineMobileDecadeNavigationClick,
        };
    };
    const mapYear = (year, decadeValue) => {
        var _a, _b, _c;
        return ({
            value: (_b = (_a = year === null || year === void 0 ? void 0 : year.fields) === null || _a === void 0 ? void 0 : _a.year) === null || _b === void 0 ? void 0 : _b.value,
            decadeValue,
            gtm: mapYearGTM(year),
            items: (_c = year.fields.items) === null || _c === void 0 ? void 0 : _c.map(mapLineItem),
        });
    };
    const reduceYears = (decade) => {
        var _a, _b;
        return (_b = (_a = decade === null || decade === void 0 ? void 0 : decade.fields) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.reduce((acc, cur) => {
            var _a, _b, _c, _d, _e, _f;
            var _g;
            const yearValue = (_b = (_a = cur === null || cur === void 0 ? void 0 : cur.fields) === null || _a === void 0 ? void 0 : _a.year) === null || _b === void 0 ? void 0 : _b.value;
            const possibleIndex = acc.keys[yearValue];
            if (possibleIndex != null && possibleIndex != undefined) {
                (_g = acc.years)[possibleIndex] && (_g[possibleIndex] = {
                    ...acc.years[possibleIndex],
                    items: [...acc.years[possibleIndex].items, ...((_d = (_c = cur.fields.items) === null || _c === void 0 ? void 0 : _c.map(mapLineItem)) !== null && _d !== void 0 ? _d : [])],
                });
                return acc;
            }
            const currentIndex = acc.years.length;
            acc.keys[yearValue] = currentIndex;
            acc.years = [...acc.years, mapYear(cur, (_f = (_e = decade === null || decade === void 0 ? void 0 : decade.fields) === null || _e === void 0 ? void 0 : _e.decade) === null || _f === void 0 ? void 0 : _f.value)];
            return acc;
        }, { keys: {}, years: [] }).years;
    };
    const mapDecade = (decade) => {
        var _a, _b;
        return ({
            value: (_b = (_a = decade === null || decade === void 0 ? void 0 : decade.fields) === null || _a === void 0 ? void 0 : _a.decade) === null || _b === void 0 ? void 0 : _b.value,
            gtm: mapDecadeGTM(decade),
            mobileGtm: mapDecadeMobileGTM(decade),
            years: reduceYears(decade),
        });
    };
    return {
        decades: (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.items) === null || _a === void 0 ? void 0 : _a.map(mapDecade)) !== null && _b !== void 0 ? _b : [],
        reduceYears,
    };
};
export const getHrefValue = (decadeValue, yearValue) => {
    if (!decadeValue || !yearValue)
        return;
    return `${decadeValue}-${yearValue}`;
};
export const onTimelineNavClick = (href) => {
    if (!href)
        return;
    if (isSSR())
        return;
    setTimeout(() => {
        // FIXME: getElementById is not the best way to query elemnt in React
        const el = document.getElementById(href !== null && href !== void 0 ? href : '');
        if (el) {
            el.scrollIntoView({ behavior: 'instant' });
        }
    }, 200);
};
